export function createUrl(base: string, params: { [key: string]: unknown }) {
  const url = new URL(base);
  Object.keys(params).forEach((key) => {
    let value = String(params[key]);

    if (value === 'undefined') {
      value = '';
    }

    if (typeof value === 'string' && value.trim().length > 0) {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

export const isInternalUser = ({ email, email_verified }: { email?: string; email_verified?: boolean }) => {
  return !!email?.endsWith('@byway.travel') && !!email_verified;
};

export const isBywayURL = (url: string | string[] | undefined) => {
  if (!url || typeof url !== 'string') {
    return false;
  }

  return url.toLowerCase().includes('byway.travel');
};
